import styles from './PromptConfiguration.module.css'

interface PromptEditorProps {
  promptText: string
  setPromptText: (text: string) => void
  lastSavedToLocalStorage: Date | null
  formatTimestamp: (date: Date | null) => string
}

function PromptEditor({
  promptText,
  setPromptText,
  lastSavedToLocalStorage,
  formatTimestamp,
}: PromptEditorProps) {
  return (
    <div className={styles.promptEditorSection}>
      <h3 className={styles.sectionLabel}>AI Prompt</h3>
      <textarea
        className={styles.promptTextarea}
        value={promptText}
        onChange={(e) => setPromptText(e.target.value)}
        placeholder='Enter the AI prompt for analyzing this section...'
      />
      <div className={styles.autoSaveIndicator}>
        Locally saved: {formatTimestamp(lastSavedToLocalStorage)}
      </div>
    </div>
  )
}

export default PromptEditor
